import React from 'react';

function Placeholder() {
  return <div>頁面維護中。</div>;
}

export default Placeholder;
